import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
export const MARK_SYSTEM_MESSAGE_AS_READ = 'MARK_SYSTEM_MESSAGE_AS_READ';


export const service = async (messageId) => {
  const options: object = {
    url:  '/Api/Utility/ReadMessage/' + messageId,
    method: "GET",
  }
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(MARK_SYSTEM_MESSAGE_AS_READ, service, mock);
